import React from "react";
import Selector from "../../../core/design-system/dropdown/Selector";
import { typeOptions } from "../../../../constants/config";
import { QuickTransferActions } from "./QuickTransferHandler";
import { AccountType } from "../../types";
import Button from "../../../core/design-system/Button/Button";
import Input from "../../../core/design-system/Input/Input";
import SelectDevice from "../../../core/components/SelectDevice";
import ApproveTransfer from "../../../core/components/ApproveTransfer.tsx";
import ResultModal from "../../../core/components/ResultModal";
import useTailwindBreakpoints from "../../../../hooks/useTailwindBreakPoints";

interface QuickTransferProps {
  accountsHave: AccountType[];
}

const QuickTransfer: React.FC<QuickTransferProps> = (props) => {
  const {
    onClickPay,
    onSelectType,
    toggleApprove,
    toggleResultModal,
    onSelectAccount,
    onChangeAmount,
    onSelectPayee,
    onChangeNote,
    setStatus,
    onSelectToAccount,
    toggleDeviceListModel,
    navigateToApproveModal,
    state,
    toAccountSelectorRef,
    accountSelectorRef,
    payeeSelectorRef,
    setErrorCodeToState,
    errorCode,
  } = QuickTransferActions(props);
  const navigateToApproveModalWrapper = (device: any) => {
    navigateToApproveModal(device);
  };
  const { lg } = useTailwindBreakpoints();

  return (
    <div className="flex flex-col bg-gray p-3 rounded-xl w-full border bg-gray-100_01 border-lightGray shadow-sm">
      <div className="flex flex-col xs:gap-[0.7rem] 5xl:gap-[1.25rem] bg-white-A700 p-3 rounded-lg">
        <div>
          <p className="text-black xs:text-lg 5xl:text-xl text-left xs:font-medium 4xl:font-normal">
            Quick Transfer
          </p>

          <p className="text-darkGray text-left xs:font-medium xs:text-sm 5xl:text-lg 4xl:font-normal">
            Enter payee name or select payee to transfer amount
          </p>
        </div>

        <div className="flex flex-row justify-between items-center gap-3">
          <div className="flex flex-col gap-2 text-left w-1/3">
            <p
              className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm
           5xl:text-lg "
            >
              {lg ? "Transfer Type" : "Type"}
            </p>
            <Selector options={typeOptions} onChange={onSelectType} />
          </div>
          <div className="flex flex-col gap-2 text-left w-1/3">
            <p className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm 5xl:text-lg">
              Account
            </p>
            <Selector
              ref={accountSelectorRef}
              options={state.haveAccountsOptions}
              onChange={onSelectAccount}
              value={state.selectedAccount}
            />
          </div>
          {state.transactionType === "OWN_ACCOUNT_TRANSFER" ? (
            <div className="flex flex-col gap-2 text-left w-1/3">
              <p className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm 5xl:text-lg">
                To Account
              </p>
              <Selector
                ref={toAccountSelectorRef}
                options={state.toAccountOptions}
                onChange={onSelectToAccount}
                value={state.toAccount}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-2 text-left w-1/3">
              <p className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm 5xl:text-lg">
                Payee
              </p>
              <Selector
                ref={payeeSelectorRef}
                options={state.payees}
                onChange={onSelectPayee}
                value={state.toAccount}
              />
            </div>
          )}
        </div>

        <div className="flex flex-row items-center gap-3">
          <div className="flex flex-col gap-2 text-left w-1/3">
            <p className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm 5xl:text-lg">
              Amount
            </p>
            <Input
              placeholder="Enter Amount"
              value={state.amount}
              onChange={onChangeAmount}
            />
          </div>

          <div className="flex flex-col gap-2 text-left w-1/3">
            <p className="text-black max-sm:text-xs md:text-xs sm:text-xs lg:text-sm xl:text-sm 5xl:text-lg">
              Note
            </p>
            <Input
              placeholder="Enter Note"
              value={state.narration}
              onChange={onChangeNote}
            />
          </div>

          <div className="flex flex-col text-left w-1/3 pt-7">
            <Button
              variant="primary"
              className="w-full 
              text-white-A700 py-2 rounded-lg xs:!h-[38px] 5xl:!h-[54px] 5xl:!text-lg 5xl:!mt-1.5"
              onClick={onClickPay}
            >
              Pay Now
            </Button>
          </div>
        </div>
      </div>

      <SelectDevice
        showModal={state.isDeviceListModelOpen}
        toggleDeviceList={toggleDeviceListModel}
        navigateToApproveModal={navigateToApproveModalWrapper}
        registrations={state.mfaPayload?.deviceList ?? []}
      />

      {state.isAppoveModelOpen && (
        <ApproveTransfer
          showModal={state.isAppoveModelOpen}
          toggleApprove={toggleApprove}
          transferData={state}
          setStatus={setStatus}
          setErrorCode={setErrorCodeToState}
        />
      )}
      <ResultModal
        status={state.approvalStatus}
        showModal={state.isResultModalOpen}
        toggleResultModal={toggleResultModal}
        transactionId={state.mfaPayload?.transactionId}
        transferData={{ ...state, errorCode }}
      />
    </div>
  );
};

export default QuickTransfer;
